import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useInputChange } from '../../helpers/useInputChange'
import { CognitoUser } from "amazon-cognito-identity-js";
import { postJson } from '../../helpers/RequestsHelper';

const ConfirmationCodePage = (props) => {
  const [email, setEmail] = useInputChange(sessionStorage.getItem("signup_email"))
  const [code, setCode] = useInputChange(props.code)
  const [error, setError] = useState()
  const [codeResending, setCodeResending] = useState()
  const history = useHistory();
  const {t} = useTranslation()

  const onSubmit = (e) => {
    e.preventDefault();
    let button = e.currentTarget;
    if (button.clicked) {
      return
    }
    button.clicked = true

    var cognitoUser = new CognitoUser({
      Username: email,
      Pool: window.userPool,
    });

    cognitoUser.confirmRegistration(code, true, async (err, result) => {
      if (err) {
        button.clicked = false
        setError(err.message)
        return
      }
      history.push("/user/profile?welcome")
    });
  }

  const onResend = (e) => {
    e.preventDefault();
    let button = e.currentTarget;
    button.disabled = true
    

    if (codeResending) {
      return
    }
    
    setTimeout(function(){ button.disabled = false }, 10000);

    setCodeResending(true)   

    var cognitoUser = new CognitoUser({
      Username: email,
      Pool: window.userPool,
    });

    cognitoUser.resendConfirmationCode(function (err, result) {
      setCodeResending(false)   
      if (err) {
        setError(err.message)
        return
      }       
    });
  }
  
  document.title = t("titleappname") + t("title_confirm_registration")
  
  return <div className="wrap-login100">
    <form className="login100-form validate-form" onSubmit={onSubmit}>
      <h3>{t("title_confirm_registration")}</h3>
      <small id="errorMessage" className="text-success">{t("account_created")}</small><br/><br/>
      <div className="wrap-input100 validate-input">
        <span className="label-input100">{t("lbl_email")}</span>
        <input className="form-control"
          type="email"
          name="email"
          autoComplete="email"
          id="email"
          placeholder={t("tip_email")}
          value={email}
          onChange={setEmail} />
        <span className="focus-input100" data-symbol="&#xf1fa;"></span>
      </div>
      <div className="wrap-input100 validate-input">
        <span className="label-input100">{t("lbl_code")}</span>
        <input className="form-control"
          type="text"
          name="code"
          autoComplete="off"
          id="code"
          placeholder={t("tip_code")}
          value={code}
          onChange={setCode}
          required={true}
          pattern="^\d{6}$" title={t("val_code")}
           />
        <span className="focus-input100" data-symbol="&#xf292;"></span>
      </div>
      {error ? <small id="errorMessage" className="text-danger">{error}<br/></small> : ""}
      <br />
      <div>
        <input type="submit" className="submit-btn" value={t("btn_confirmation_submit")} />
      </div>
      <br />
      <span>{t("lbl_resubmit_code")}</span>
      <br />
      <div>
        <input type="button" className="submit-btn-2" value={codeResending ? t("btn_confirmation_resending") : t("btn_confirmation_resend")} onClick={onResend}/>
      </div>
    </form>
  </div>
}

export default ConfirmationCodePage
